import { Switch } from '@mantine/core'
import type { ComponentProps } from 'react'
import { colors } from 'settings/colors'
import { useIsWideScreen } from 'utils/useIsWideScreen'

type MantineSwitchProps = ComponentProps<typeof Switch>

export const SectionTitleBarSwitch = ({ checked, ...MantineSwitchProps }: MantineSwitchProps) => {
  const isWideScreen = useIsWideScreen()

  return (
    <Switch
      css={{ cursor: 'pointer' }}
      size={isWideScreen ? 'sm' : 'md'}
      checked={checked}
      styles={{
        track: {
          cursor: 'unset',
          backgroundColor: checked ? colors.green : colors.grey500,
          borderColor: checked ? colors.green : colors.grey500,
        },
      }}
      {...MantineSwitchProps}
    ></Switch>
  )
}
